import React from 'react'
import { VisuallyHiddenPropTypes } from './types'
import styles from './visually_hidden.module.css'

export const VisuallyHidden: React.FC<VisuallyHiddenPropTypes> = ({ children, ...delegated }) => {
  return (
    <span {...delegated} className={styles.hidden}>
      {children}
    </span>
  )
}
export default VisuallyHidden
